import UserpilotUtils from 'app/utils/userpilot';
import { PageThunk } from 'modules/page/pageActions';
import { useDispatch } from 'react-redux';
import Logger from 'utils/logger';
import { NewAddedPage } from 'types/Page';
import { useQueryClient } from 'react-query';
import { AccountThunks } from 'modules/account/accountActions';

type Props = {
  onProfileAdded?: (profileId: number) => void;
};

/**
 * What follows a connect: tracking, the refresh, and the host's callback. The
 * modal stays open on the success view, which owns the way out (close, Add
 * more, back to the disconnected profiles).
 */
const useAddNewProfileAutomatically = ({ onProfileAdded }: Props) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  function onPageAdded(addedPage: NewAddedPage) {
    Logger.log('Profiles added', addedPage);

    const hasAddedMore = addedPage.ids.length > 1;
    const idToSelect = addedPage.ids[0];

    UserpilotUtils.track(
      hasAddedMore
        ? UserpilotUtils.events.SOCIAL_MEDIA_PROFILES_CONNECTED
        : UserpilotUtils.events.SOCIAL_MEDIA_PROFILE_CONNECTED,
    );

    dispatch(PageThunk.requestPages());
    dispatch(AccountThunks.requestAccount());
    queryClient.invalidateQueries();

    if (idToSelect && onProfileAdded) {
      onProfileAdded(idToSelect);
    }
  }

  return {
    onPageAdded,
  };
};

export default useAddNewProfileAutomatically;
